import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import NavigationComponent from "./components/navigation/NavigationComponent";
import HomeComponent from "./components/home/HomeComponent";
import NotFound from "./utils/NotFound";
import LoginComponent from "./auth/LoginComponent";
import AddCourse from "./components/courses/AddCourse";
import CourseList from "./components/courses/CourseList";
import SignupComponent from "./auth/SignupComponent";
import Dashboard from "./dashboard/Dashboard";
import { useAuthContext } from "./hooks/useAuthContext";
import CourseDetails from "./components/courses/CourseDetails";
import Loading from "./utils/Loading";
import About from "./pages/About";
import { Footer } from "./footer/Footer";
import Setting from "./dashboard/Setting";
import CourseTable from "./components/courses/CourseTable";
import { CourseContentDetails } from "./components/courses/CourseContentDetails";
import UsersList from "./dashboard/UsersList";
import MyProfile from "./dashboard/MyProfile";
import SubscribersList from "./subscribe/SubscribersList";
import { UpdateUser } from "./dashboard/UpdateUser";
import ResetPassword from "./auth/ResetPassword";
import ForgotPassword from "./auth/ForgotPassword";
import BlogList from "./blog/BlogList";
import AddBlog from "./blog/AddBlog";
import ContactMe from "./contact/ContactMe";
import BlogDetails from "./blog/BlogDetails";
import { UserProfile } from "./dashboard/UserProfile";
import MyCourses from "./components/courses/MyCourses";
import ShoppingCart from "./cart/ShoppingCart";
import PortfolioComponent from "./portfolio/PortfolioComponent";
import BlogUpdate from "./blog/BlogUpdate";
import ContactsList from "./contact/ContactsList";
import AddNewJobs from "./JobPortal/AddNewJobs";
import JobDetails from "./JobPortal/JobDetails";
import JobPortal from "./JobPortal/JobPortal";
import JobApplication from "./JobPortal/JobApplication";
import HelpFAQ from "./utils/HelpFAQ";
import PrivacyPolicy from "./privacy/PrivacyPolicy";
function App() {
  const [loading, setLoading] = useState(true);
  const [reloaded, setReloaded] = useState(false);
  const { user } = useAuthContext();

  useEffect(() => {
    // Check if we've already reloaded
    if (!reloaded) {
      const hasReloaded = sessionStorage.getItem("hasReloaded");

      if (!hasReloaded) {
        sessionStorage.setItem("hasReloaded", "true");
        window.location.reload();
        return;
      }
    }

    // If we've already reloaded or don't need to, proceed with normal loading
    const timer = setTimeout(() => {
      setLoading(false);
      setReloaded(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [reloaded]);

  if (loading) {
    return <div>{<Loading />}</div>;
  }

  return (
    <div className="home-app">
      <BrowserRouter>
        <React.Fragment>
          {/* {!user && (
            <>
              {" "}
              <NavigationComponent />
            </>
          )} */}
          <NavigationComponent />
          <Routes>
            <Route
              path="/api/dashboard/*"
              element={user ? <Dashboard /> : <Navigate to="/" />}
            >
              <Route path="subscribers" element={<SubscribersList />} />

              <Route path="users" element={<UsersList />} />
              <Route path="create" element={<AddBlog />} />
              <Route path="blogs" element={<BlogList />} />

              <Route path="my-profile" element={<MyProfile />} />
              <Route path="user-profile/:id" element={<UserProfile />} />
              <Route path="update-user/:id" element={<UpdateUser />} />
              <Route path="setting" element={<Setting />} />
              <Route
                path="course-content-details/:id"
                element={<CourseContentDetails />}
              />
              <Route path="course-table" element={<CourseTable />} />
              <Route path="add-course" element={<AddCourse />} />

              <Route path="my-courses" element={<MyCourses />} />
              <Route path="all-contacts" element={<ContactsList />} />
            </Route>

            <Route
              path="/api/courses/course-details/:id/:title"
              element={<CourseDetails />}
            />

            <Route
              path="/api/courses/shopping-cart"
              element={<ShoppingCart />}
            />
            {/* Forget  */}

            <Route
              path="/api/users/forgot-password"
              element={<ForgotPassword />}
            />
            <Route
              path="/api/users/reset-password"
              element={<ResetPassword />}
            />

            <Route path="/api/blog/edit/:id" element={<BlogUpdate />} />
            <Route
              path="/api/blogs/blog-details/:id/:title"
              element={<BlogDetails />}
            />
            <Route path="/api/blogs" element={<BlogList />} />
            {/* Jobs link */}
            <Route path="/api/jobs/all-jobs" element={<JobPortal />} />
            <Route path="/api/jobs/add-new-job" element={<AddNewJobs />} />
            <Route
              path="/api/jobs/job-details/:id/:title"
              element={<JobDetails />}
            />

            {/* Job Applications */}
            <Route path="/api/jobs/applications" element={<JobApplication />} />

            <Route path="/api/portfolio" element={<PortfolioComponent />} />
            <Route path="/api/about" element={<About />} />
            <Route path="/api/courses" element={<CourseList />} />
            <Route path="/api/users/login" element={<LoginComponent />} />
            <Route path="/api/users/register" element={<SignupComponent />} />
            {/* Contact */}
            <Route path="/api/get-in-touch/contact" element={<ContactMe />} />

            {/* Help FAQ */}
            {!user && <Route path="/api/help-faq" element={<HelpFAQ />} />}
            <Route path="/api/help-faq" element={<HelpFAQ />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/" exact element={<HomeComponent />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </React.Fragment>{" "}
        {/* <Footer /> */}
        {/* {!user && (
          <> */}
        <Footer />
        {/* </>
        )} */}
      </BrowserRouter>
    </div>
  );
}

export default App;
